import { commentItems } from '@/mocks/homeData';

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100 text-center mb-3">
          观众热评
        </h2>
        <p className="text-foreground-400 text-sm text-center mb-10">
          听听影迷们怎么说
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {commentItems.map((item) => (
            <div
              key={item.name}
              className="bg-background-50 border border-background-200/30 rounded-xl p-5 hover:border-background-300/40 transition-colors"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-bold text-foreground-100 truncate">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-1 text-foreground-500 text-xs">
                <div className="w-5 h-5 flex items-center justify-center cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i>
                </div>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}